module.exports = __webpack_public_path__ + "img/product_13.a4f76f3.webp";